import { createSelector } from 'reselect';

const getReducer = state => state.campaigns;

export const archivedColumnsSelector = createSelector(
  state => getReducer(state).archivedColumns,
  archivedColumns => archivedColumns
);

export const campaignsColumnsSelector = createSelector(
  state => getReducer(state).campaignsColumns,
  campaignsColumns => campaignsColumns
);

export const currentTabSelector = createSelector(
  state => getReducer(state).currentTab,
  currentTab => currentTab
);

export const endWeekSelector = createSelector(
  state => getReducer(state).endWeek,
  endWeek => endWeek
);

export const errorMessageSelector = createSelector(
  state => getReducer(state).errorMessage,
  errorMessage => errorMessage
);

export const selectedCampaignSelector = createSelector(
  state => getReducer(state).selectedCampaign,
  selectedCampaign => selectedCampaign
);

export const campaignIdSelector = createSelector(
  state => getReducer(state).campaignId,
  campaignId => campaignId
);

export const detailsSelector = createSelector(
  state => getReducer(state).details,
  details => details
);

export const showSelector = createSelector(
  state => getReducer(state).show,
  show => show
);
